import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import * as _ from 'lodash';
import { SettingsService } from './settings.service';
import { whilst } from 'async-es';
import { Restangular } from 'ngx-restangular';
import * as moment from 'moment';
import { of } from 'rxjs/observable/of';

@Injectable({
  providedIn: 'root',
})
export class Employee {
  id: string;
  name: string;
  email: string;
  phone: number;
}

@Injectable({
  providedIn: 'root',
})
export class ApiSettingsService {
  authKey = this.appSettings.configSettings.authKey;
  apiKey = this.appSettings.configSettings.apiKey;
  apiHeader = {
    site_uuid: '3ed9303c-f34f-d395-7d12-3403faac3f8b',
    dco_site_id: 1,
    datatype: 1,
    auth_key: this.authKey,
    api_key: this.apiKey,
  };
  apiMethods = {
    get: {
      method: 'GET',
      headers: this.apiHeader,
    },
    post: {
      method: 'POST',
      transformRequest: function (data) {
        return $.param(data);
      },
      headers: _.extend(
        { 'Content-Type': 'application/x-www-form-urlencoded' },
        this.apiHeader,
      ),
    },
    save: {
      method: 'POST',
      headers: this.apiHeader,
    },
    query: {
      method: 'GET',
      isArray: true,
      headers: this.apiHeader,
    },
    remove: {
      method: 'DELETE',
      headers: this.apiHeader,
    },
    delete: {
      method: 'POST',
      headers: _.extend({}, this.apiHeader, {
        'X-HTTP-Method-Override': true,
        method: 'DELETE',
      }),
    },
    add: {
      method: 'POST',
      headers: this.apiHeader,
    },
    update: {
      method: 'PUT',
      headers: this.apiHeader,
    },
  };
  //    const apiHeader = {site_uuid:'3ed9303c-f34f-d395-7d12-3403faac3f8b',datatype:1,auth_key:appSettings.configSettings.apiKey};
  getApiHeader = () => {
    // console.log('getting ApiHeader');
    return {
      site_uuid: '3ed9303c-f34f-d395-7d12-3403faac3f8b',
      dco_site_id: 1,
      datatype: 1,
      auth_key: this.appSettings.configSettings.authKey,
      api_key: this.appSettings.configSettings.apiKey,
    };
  };

  constructor(private appSettings: SettingsService) {}

  getApiMethods = () => {
    // console.log('getting ApiMethods');
    _.each(this.apiMethods, function (d, k) {
      this.apiMethods[k].headers.auth_key =
        this.appSettings.configSettings.authKey;
      this.apiMethods[k].headers.api_key =
        this.appSettings.configSettings.apiKey;
    });
    return this.apiMethods;
  };
}

@Injectable({
  providedIn: 'root',
})
export class AccessService {
  // Define API
  // apiURL = 'http://localhost:3000';
  me: any = {};
  apiURL = this.appSettings.apiUrl() + '/access';
  apiHeader = this.apiSettings.getApiHeader();

  constructor(
    private appSettings: SettingsService,
    private apiSettings: ApiSettingsService,
    //    private efoEgi: EfoEgiService,
    private restangular: Restangular,
  ) {}

  waitForAuth = (callback) => {
    whilst(
      (cb) => {
        cb(null, !_.has(this, 'me.groups'));
      },
      (cb2) => {
        setTimeout(() => {
          console.log('waiting for auth..');
          cb2();
        }, 1000);
      },
      (err, result) => {
        console.log('ACCESS GRANTED');
        callback();
      },
    );
  };

  private extractData(res: Response) {
    const body = res;
    return body || {};
  }

  checkUserAccess(api_key): Observable<any> {
    if (
      _.has(this.me, 'status') &&
      _.has(this.me, 'groups') &&
      this.me.auth_expiry > moment().unix()
    ) {
      return of(this.me);
    }
    return this.checkAuth(api_key).pipe(
      switchMap((response) => {
        //switchMap used when combining observables
        console.log('mike', response);
        this.me = response;
        if (response.status == 0) {
          return of(this.me);
        }
        return this.restangular
          .all('access')
          .get(
            'myGroups',
            _.omitBy(
              {
                rand: moment().unix(),
                api_key: api_key,
              },
              _.isNull,
            ),
          )
          .pipe(
            map<Restangular, Restangular>((myGroups) => {
              this.me.groups = myGroups.plain();
              this.appSettings.configSettings.apiKey = response.api_key;
              this.appSettings.set(this.appSettings.configSettings);
              return this.me;
            }),
          );
      }),
    );
  }

  checkUserAccessOld = (api_key?) => {
    let tmp_me = this.me;
    //return;
    this.checkAuth(api_key).subscribe(
      (response) => {
        if (response.status === 0) {
          this.me = response;
          return this.me;
        } else {
          tmp_me = _.extend(tmp_me, response); // so it doesn't remove the other info
          //this.efoEgi.getData('/access/myGroups', {}).subscribe(
          this.restangular
            .all('access')
            .get('myGroups')
            .subscribe((myGroups) => {
              tmp_me.groups = myGroups;
              console.log('tmp_me', tmp_me);
              this.me = tmp_me;
            });
        }
      },
      (error) => {
        console.debug('CheckAccess Error', error);
      },
    );
  };
  isInGroup = (group_name, value) => {
    //console.log(this.me,!_.isUndefined(this.me.groups),group_name,value);
    return (
      _.has(this.me, 'groups') && _.includes(this.me.groups[group_name], value)
    );
  };

  /*========================================
    CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  login(data): Observable<any> {
    return this.restangular
      .all('access')
      .all('login')
      .post(data)
      .pipe(
        map<Restangular, Restangular>((result) => {
          console.log('this is the result', result);
          return result.plain();
        }),
      );
  }

  logout(data): Observable<any> {
    return this.restangular
      .all('access')
      .all('logout')
      .post(data)
      .pipe(
        map<Restangular, Restangular>((result) => {
          console.log('this is the result', result);
          return result.plain();
        }),
      );
  }

  checkAuth(api_key?): Observable<any> {
    return this.restangular
      .all('access')
      .get(
        'checkAuth',
        _.omitBy(
          {
            rand: moment().unix(),
            api_key: api_key,
          },
          _.isNull,
        ),
      )
      .pipe(map<Restangular, Restangular>((response) => response.plain()));
  }

  isAuthenticated() {
    return _.has(this, 'me.groups') && this.me.status == 1;
  }

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(errorMessage);
  }
}
